import React from 'react';

function convert(labelValue) {
  // Nine Zeroes for Billions
  return Math.abs(Number(labelValue)) >= 1.0e9
    ? (Math.abs(Number(labelValue)) / 1.0e9).toFixed(2) + 'B'
    : // Six Zeroes for Millions
      Math.abs(Number(labelValue)) >= 1.0e6
      ? (Math.abs(Number(labelValue)) / 1.0e6).toFixed(2) + 'M'
      : // Three Zeroes for Thousands
        Math.abs(Number(labelValue)) >= 1.0e3
        ? (Math.abs(Number(labelValue)) / 1.0e3).toFixed(2) + 'K'
        : Math.abs(Number(labelValue));
}

function StatsFrame({ data, onFlyTo }) {
  const handleFlyTo = () => {
    if (data?.coordinates && data?.bounds) {
      onFlyTo({
        latitude: data.coordinates[1],
        longitude: data.coordinates[0],
        bounds: data.bounds,
      });
    } else if (data?.coordinates) {
      onFlyTo({
        latitude: data.coordinates[1],
        longitude: data.coordinates[0],
      });
    }
  };

  return (
    <div className="stats-frame">
      <h2>Santa's Stats</h2>
      <p>
        <strong>Total Miles Traveled:</strong> {convert(data?.miles || 0)}
      </p>
      <p>
        <strong>Total Gifts Delivered:</strong> {convert(data?.gifts || 0)}
      </p>
      <p>
        <strong>Current Location:</strong>{' '}
          {data?.location ? (
            <a
              href="#!"
              onClick={handleFlyTo}
              style={{
               color: 'green',
                textDecoration: 'none',
               fontWeight: 'bold',
              }}
              onMouseEnter={(e) => (e.target.style.color = 'red')}
              onMouseLeave={(e) => (e.target.style.color = 'green')}
            >
              {data.location}
            </a>
          ) : (
            'Unknown'
          )}
      </p>
    </div>
  );
}

export default StatsFrame;
